import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ExpansionPanelComponent, RessourcesModule],
    selector: 'app-deposit-validation-error-list',
    styleUrl: './deposit-validation-error-list.component.scss',
    templateUrl: './deposit-validation-error-list.component.html',
})
export class DepositValidationErrorListComponent {
    public readonly dataToDisplay = input.required<string[]>();
    public readonly title = input.required<string>();
}
